import { createWidget } from '@alfa-bank/site-util-create-widget';

import { FormValidFieldHighlighter as Component } from './form-vaild-field-highlighter';
import type { IPublicProps } from './models';

export const FormValidFieldHighlighter = createWidget<unknown, IPublicProps>()(Component);
